import icon_javascript from './../assets/icons/technologies/02_javascript.svg';
import icon_typescript from './../assets/icons/technologies/03_typescript.svg';
import icon_react from './../assets/icons/technologies/06_react.svg';
import icon_angular from './../assets/icons/technologies/05_angular.svg';
import icon_sass from './../assets/icons/temp/sass.svg';
import icon_bootstrap from './../assets/icons/temp/bootstrap.svg';
import icon_tailwind from './../assets/icons/temp/tailwind.svg';

import icon_csharp from './../assets/icons/technologies/09_csharp.svg';
import icon_dotnet from './../assets/icons/temp/dotnet.svg';
import icon_nodejs from './../assets/icons/temp/nodejs2.svg';

import icon_azure from './../assets/icons/temp/azure.svg';
import icon_docker from './../assets/icons/temp/docker.svg';
import icon_vercel from './../assets/icons/temp/vercel.svg';

import icon_sql_server from './../assets/icons/temp/sql-server.svg';
import icon_mongo from './../assets/icons/temp/mongo.svg';

import icon_python from './../assets/icons/technologies/10_python.svg';
import icon_jupyter from './../assets/icons/temp/jupyter.svg';

import icon_github from './../assets/icons/temp/github.svg';
import icon_git from './../assets/icons/temp/git2.svg';
import icon_postman from './../assets/icons/temp/postman.svg';
import icon_ssms from './../assets/icons/temp/ssms.png';

const profileData = {
  profile: {
    full_name: 'Danny Thinh Tran',
    first_name: 'Danny',
    last_name: 'Tran',
    birth_date: '2001-01-14',
    city: 'Oslo',
    country: 'Norway',
    work_availability: true,
    about: [
      "I'm an aspiring Fullstack Software Developer with a passion for building web applications using modern technologies like React, TypeScript and Tailwind CSS. On the backend, I design robust REST APIs and scalable serverless solutions using .NET and Azure Functions. I also leverage Python and tools like Pandas and NumPy to analyze data and uncover actionable insights.",
      'Driven by a passion for creating innovative solutions that make a difference, I thrive on learning and handling complex problems with creative solutions. My personality blends curiosity, adaptability, and persistence, which keep me open to new perspectives and never limited by unfamiliar languages or frameworks.',
      "In my free time, you'll find me building personal software projects and experimenting with new technologies as I prepare to take the next step in professional software development, where I look forward to making a meaningful impact through my work.",
    ]
  },
  socials: {
    contactEmail: 'contact@mail.dannytran.no',
    outlook: 'dan2816@outlook.com',
    gmail: 'dannytt14@gmail.com',
    github: 'https://github.com/danny1401',
    linkedin: 'https://www.linkedin.com/in/danny-thinh-tran-24620a206/',
    instagram: 'https://www.instagram.com/dannytrxn/',
  },
  stack: {
    frontend: {
      title: 'Frontend',
      skill: [
        ['JavaScript', icon_javascript],
        ['TypeScript', icon_typescript],
        ['React', icon_react],
        ['Angular', icon_angular],
        ['Bootstrap', icon_bootstrap],
        ['Sass', icon_sass],
        ['Tailwind CSS', icon_tailwind],
      ]
    },
    backend: {
      title: 'Backend',
      skill: [
        ['C#', icon_csharp],
        ['.NET', icon_dotnet],
        ['Node.Js', icon_nodejs],
      ]
    },
    cloud: {
      title: 'Sky',
      skill: [
        ['Azure', icon_azure],
        ['Docker', icon_docker],
        ['Vercel', icon_vercel],
      ]
    },
    database: {
      title: 'Database',
      skill: [
        ['MongoDB', icon_mongo],
        ['Microsoft SQL Server', icon_sql_server],
      ]
    },
    data: {
      title: 'Data',
      skill: [
        ['Python', icon_python],
        ['Jupyter Notebook', icon_jupyter],
      ]
    },
    tools: {
      title: 'Verktøy', 
      skill: [
        ['Github', icon_github],
        ['Git', icon_git],
        ['Postman', icon_postman],
        ['Microsoft SQL Server Management Studio', icon_ssms],
      ]
    },
  },
  experience: [
    {
      title: 'Frontend Developer (Intern)',
      company: 'Knitry',
      start_date: 'Jan. 2022',
      end_date: 'Jul. 2022',
      city: 'Oslo',
      country: 'Norway',
      description: [
          'The internship revolved around the development of a frontend web application for their digital platform.' ,
          'I was programming in TypeScript using Angular, as well as collaborating with backend developers to implement a RESTful API.', 
          'This internship gave me practical experience in building a user-oriented UI components that utilizes API functionality.',
      ],
      tags: [['TypeScript', icon_typescript], ['Angular', icon_angular]],
      href: '',
    },
    {
      title: 'Fullstack Developer (Bachelor Thesis)',
      company: 'Epinova',
      start_date: 'Jan. 2023',
      end_date: 'Jun. 2023',
      city: 'Oslo',
      country: 'Norway',
      description: [
        "The bachelor's thesis involved developing a web application using React and .NET.", 
        'During this period, I worked on UI/UX, frontend, backend, database, and user authentication.',
        'This project not only improved my technical skills, but also strengthened my ability to develop a product from concept to implementation.'
      ],
      tags: [['.NET', icon_dotnet], ['React', icon_react]],
      href: '',
    },
  ],
  education: [ 
    {
      degree: 'Bachelor',
      program: 'Information Technology',
      start_date: 'Aug. 2020',
      end_date: 'Jun. 2023',
      university: 'Oslo Metropolitan University',
      city: 'Oslo',
      country: 'Norway',
      description: '',
    },
    {
      degree: 'Master',
      program: 'Informatics: Programming and System Architecture',
      start_date: 'Aug. 2023',
      end_date: 'Jan. 2026',
      university: 'University of Oslo',
      city: 'Oslo',
      country: 'Norway',
      description: '',
    },
  ],
  interest:{
    deck: [
      { id: 1, src: 'https://picsum.photos/id/1015/600/800', title: 'Travels' },
      { id: 2, src: 'https://picsum.photos/id/1025/600/800', title: 'Lifting' },
      { id: 3, src: 'https://picsum.photos/id/1035/600/800', title: 'NYC' },
      { id: 4, src: 'https://picsum.photos/id/1043/600/800', title: 'Projects' },
      { id: 5, src: 'https://picsum.photos/id/1050/600/800', title: 'Life' },
    ],
  },
};

export default profileData;
